module.exports = __webpack_public_path__ + "img/cave153.60334a8d.jpg";